var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[(_vm.reloading)?_c('div',{attrs:{"id":"loading"}},[_vm._v("...LOADING...")]):_vm._e(),_c('div',{staticClass:"chart-container",attrs:{"id":"amChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }